import { isElementType } from '@lumapps/wrex/slate/utils/isElementType';

import { LinkPreview } from '../components/blocks/LinkPreview';

export const isLinkPreview = isElementType(LinkPreview);
